var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.6676 0.0029428C117.059 0.00295004 150.667 33.6112 150.667 75.0026L150.667 150.002L75.6676 150.002C34.2762 150.002 0.667948 116.394 0.667956 75.0025C0.667963 33.6111 34.2762 0.00293556 75.6676 0.0029428Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.2796 47.2222C11.249 47.2222 0.668636 36.6418 0.668636 23.6112V0.000183105H24.2796C37.3103 0.000183105 47.8906 10.5806 47.8906 23.6112C47.8906 36.6418 37.3103 47.2222 24.2796 47.2222Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3_2",
    d: "M23.8025 33.7498C27.7365 33.7498 30.687 31.3924 30.6677 28.1985C30.687 25.7081 29.1249 23.902 26.5601 23.5218V23.3697C28.6235 22.7994 29.9349 21.1834 29.9156 18.9781C29.9349 16.1834 27.64 13.75 23.8796 13.75C20.3699 13.75 17.4579 15.8222 17.3422 18.902H19.7142C19.8106 17.0009 21.739 15.8602 23.841 15.8602C26.0973 15.8602 27.5436 17.153 27.5436 19.0922C27.5436 21.1074 25.8659 22.4381 23.4553 22.4381H21.8548V24.5674H23.4553C26.5408 24.5674 28.2571 26.0693 28.2571 28.1795C28.2571 30.2137 26.3673 31.6016 23.7639 31.6016C21.4112 31.6016 19.5406 30.4419 19.4056 28.5978H16.918C17.053 31.6776 19.8685 33.7498 23.8025 33.7498Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M117.292 61.1938H36.9902V109.686H117.292V61.1938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M118.176 110.581H36.0977V60.2979H118.176V110.581ZM37.8744 108.79H116.39V62.0892H37.8833V108.79H37.8744Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M114.604 107.008H39.668V63.8809H114.604V107.008Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.4088 55.3262H70.917C74.3455 55.3262 77.1312 57.9863 77.1312 61.2645V108.476C77.1312 105.197 74.3455 102.537 70.917 102.537H44.4088C44.2659 102.537 44.132 102.546 43.998 102.564V55.3441C44.132 55.3441 44.2748 55.3262 44.4088 55.3262Z",
    fill: "#EAEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M48.8729 59.8045H75.3812C75.9348 59.8045 76.4794 59.8852 76.9883 60.0106C76.3901 57.3325 73.8991 55.3262 70.917 55.3262H44.4088C44.2659 55.3262 44.132 55.3351 43.998 55.3441V102.564C44.132 102.555 44.2748 102.537 44.4088 102.537H48.4622V59.8225C48.5961 59.8225 48.739 59.8045 48.8729 59.8045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M78.0243 108.474H76.2386C76.2386 105.698 73.8547 103.432 70.9173 103.432H44.409C44.2929 103.432 44.1858 103.441 44.0697 103.449L43.1055 103.53V54.5009L43.9358 54.4471C44.1412 54.4292 44.2751 54.4292 44.409 54.4292H70.9173C74.8368 54.4292 78.0243 57.4924 78.0243 61.2632V108.474ZM44.8911 101.64H70.9173C73.0333 101.64 74.935 102.536 76.2386 103.951V61.2632C76.2386 58.4866 73.8547 56.2205 70.9173 56.2205H44.8911V101.64Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M97.3427 55.3296H111.101C111.173 55.3296 111.244 55.3296 111.316 55.3296C111.387 55.3296 111.458 55.3296 111.53 55.3385V92.6434L106.592 97.5965L101.655 102.55H83.5841C81.8074 102.55 80.1913 103.212 79.0217 104.287C77.8521 105.362 77.1289 106.849 77.1289 108.488V61.2679C77.1289 59.6288 77.8521 58.142 79.0217 57.0672C80.1913 55.9924 81.7984 55.3296 83.5841 55.3296H91.9589",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M78.0415 108.476H76.2559V61.2652C76.2559 59.429 77.0326 57.7004 78.4344 56.4106C79.8183 55.1387 81.6486 54.4401 83.595 54.4401H91.9698C92.4608 54.4401 92.8626 54.8432 92.8626 55.3358C92.8626 55.8284 92.4608 56.2315 91.9698 56.2315H83.595C82.095 56.2315 80.6932 56.7689 79.6397 57.7362C78.604 58.6856 78.0415 59.9396 78.0415 61.2741V104.007C78.1665 103.872 78.3005 103.747 78.4344 103.613C79.8183 102.341 81.6486 101.633 83.595 101.633H101.3L110.648 92.2555V56.2225H97.3536C96.8625 56.2225 96.4607 55.8194 96.4607 55.3268C96.4607 54.8342 96.8625 54.4312 97.3536 54.4312H111.112C111.201 54.4312 111.291 54.4312 111.38 54.4312L112.362 54.4938L112.434 55.3358V93.0168L102.041 103.442H83.595C82.095 103.442 80.6932 103.98 79.6397 104.947C78.604 105.897 78.0415 107.151 78.0415 108.485V108.476Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M115.029 51.0784H113.266C112.84 51.0784 112.506 50.7434 112.506 50.317C112.506 49.8907 112.84 49.5557 113.266 49.5557H115.029C115.455 49.5557 115.789 49.8907 115.789 50.317C115.789 50.7434 115.455 51.0784 115.029 51.0784Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M119.906 51.0784H118.143C117.717 51.0784 117.383 50.7434 117.383 50.317C117.383 49.8907 117.717 49.5557 118.143 49.5557H119.906C120.331 49.5557 120.666 49.8907 120.666 50.317C120.666 50.7434 120.331 51.0784 119.906 51.0784Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M116.594 49.5239C116.168 49.5239 115.834 49.1889 115.834 48.7625V47.0114C115.834 46.585 116.168 46.25 116.594 46.25C117.02 46.25 117.354 46.585 117.354 47.0114V48.7625C117.354 49.1889 117.02 49.5239 116.594 49.5239Z",
    fill: "#F58B93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M116.594 54.4122C116.168 54.4122 115.834 54.0772 115.834 53.6508V51.8844C115.834 51.4581 116.168 51.123 116.594 51.123C117.02 51.123 117.354 51.4581 117.354 51.8844V53.6508C117.354 54.0772 117.02 54.4122 116.594 54.4122Z",
    fill: "#F58B93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M111.532 92.668H102.095C101.952 92.668 101.809 92.659 101.666 92.6411V102.565L111.532 92.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M101.666 103.46C101.55 103.46 101.434 103.442 101.327 103.389C100.997 103.254 100.773 102.923 100.773 102.565V92.6406C100.773 92.3898 100.881 92.148 101.059 91.9778C101.247 91.8076 101.497 91.7181 101.738 91.7449C101.854 91.7539 101.979 91.7629 102.095 91.7629H111.532C111.889 91.7629 112.22 91.9778 112.354 92.3182C112.487 92.6585 112.416 93.0347 112.157 93.2945L102.291 103.192C102.122 103.362 101.889 103.451 101.657 103.451L101.666 103.46ZM102.559 93.5632V100.406L109.38 93.5632H102.559Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M62.2102 63.9302H53.4961V65.7215H62.2102V63.9302Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M60.2995 69.8604H53.4961V71.6517H60.2995V69.8604Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M58.996 75.7808H53.4961V77.5721H58.996V75.7808Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M62.2102 81.7012H53.4961V83.4925H62.2102V81.7012Z",
    fill: "#C3A1F3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M99.2648 77.2258H89.9258L94.5953 65.9761L99.2648 77.2258ZM92.6043 75.4344H96.5863L94.5953 70.6425L92.6043 75.4344Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M99.3267 82.0417L97.3268 77.223H91.8626L89.8538 82.0417L88.2109 81.3521L90.6662 75.4316H98.5143L100.978 81.3521L99.3267 82.0417Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M56.7028 90.0581H54.0957V91.8495H56.7028V90.0581Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M61.8004 90.0581H59.1934V91.8495H61.8004V90.0581Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M66.8981 90.0581H64.291V91.8495H66.8981V90.0581Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M42.7212 118.765C49.3781 118.765 54.7745 113.352 54.7745 106.674C54.7745 99.9956 49.3781 94.582 42.7212 94.582C36.0644 94.582 30.668 99.9956 30.668 106.674C30.668 113.352 36.0644 118.765 42.7212 118.765Z",
    fill: "#FA7982"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M37.5652 105.785L42.768 112.404L47.9707 105.785L45.1141 105.785L45.1141 100.839L40.4218 100.839L40.4218 105.785L37.5652 105.785Z",
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet3);
export default __webpack_public_path__ + "static/media/item_tablet_3.1393d26245d6b85ff8c3cbb74344edd8.svg";
export { ForwardRef as ReactComponent };